export default "__VITE_ASSET__6e8151c1__"